import React from 'react';
import Icon from '../ui/Icon';
import PropTypes from 'prop-types';
import { light } from '../theme/colors';
import styled from 'styled-components';

const IconButtonWrapper = styled.div`
  cursor: pointer;
`;

const IconButton = props => (
  <IconButtonWrapper className="icon-button pr-0" {...props}>
    <span className="mr-3">
      <Icon colour={light} icon={props.icon} />
    </span>
    <span className="d-none d-lg-inline">{props.label}</span>
    <span className="d-lg-none">{props.textshort}</span>
  </IconButtonWrapper>
);

IconButton.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  textshort: PropTypes.string,
};

export default IconButton;
